/// <amd-module name="Feed/CreateFeed/Redux/CreateFeed/CreateFeedReducers" />
import { CreateFeedActions, CreateFeedActionTypes } from "Feed/CreateFeed/Redux/CreateFeed/CreateFeedActions";
import { ICreateFeedState, Visibility } from "Feed/CreateFeed/Redux/CreateFeed/CreateFeedContracts";
import produce from "immer";

export const createFeedReducer = produce((draft: ICreateFeedState, action: CreateFeedActions) => {
    switch (action.type) {
        case CreateFeedActionTypes.CreateFeed:
            draft.errorMessage = undefined;
            break;

        case CreateFeedActionTypes.SaveStarted:
            draft.isSaving = true;
            break;

        case CreateFeedActionTypes.SaveCompleted:
            draft.isSaving = false;
            break;

        case CreateFeedActionTypes.SaveFailed:
            draft.errorMessage = action.payload.errorMessage;
            draft.isSaving = false;
            break;

        case CreateFeedActionTypes.SetError:
            draft.errorMessage = action.payload.errorMessage;
            draft.isSaving = false;
            break;
    }
}, getDefaultCreateFeedState());

export function getDefaultCreateFeedState() {
    return {
        isSaving: false,
        isProjectScoped: true,
        errorMessage: undefined,
        feedName: "",
        upstreamSources: true,
        visibility: Visibility.collection
    } as ICreateFeedState;
}
